export default __webpack_public_path__ + "static/media/CJ_Showcase.5e533e3f.jpg";